import React from 'react';
import { SectionHeading } from './SectionHeading';
import { changeNeeds, changeRows, changeSteps } from '../data/content';
export function ChangeSection() {
  return <section className="bg-sand py-12 md:py-20 px-4" data-id="element-31" data-mp="zpliv9ll3j2h">
      <div className="max-w-5xl mx-auto" data-id="element-32" data-mp="lvkrx20vj0co">
        <SectionHeading eyebrow="El cambio" title="No siempre necesitas pensar más. A veces necesitas otra forma de sacar lo que llevas dentro." data-id="element-33" data-mp="lujeiqwdy1rs" />

        <div className="bg-white rounded-2xl border border-sand-deep overflow-hidden" data-id="element-34" data-mp="bwvatbgsxjxh">
          <div className="hidden md:grid grid-cols-[1fr_1.3fr_1.3fr] border-b border-sand-deep font-sans text-[11px] font-bold uppercase tracking-wider" data-id="element-35" data-mp="gyuekmggeiuy">
            <span className="px-6 py-3" data-id="element-36" data-mp="7wbgefnm4uf1" />
            <span className="px-6 py-3 text-forest/55" data-id="element-37" data-mp="7x4mrfinthwn">Ahora</span>
            <span className="px-6 py-3 text-terracotta-deep bg-sage-light/60" data-id="element-38" data-mp="1xb9gfxts07fl">Con Pausa Propia</span>
          </div>
          <ul className="divide-y divide-sand-deep" data-id="element-39" data-mp="229kqo9nzgjyc">
            {changeRows.map(row => <li key={row.situation} className="md:grid md:grid-cols-[1fr_1.3fr_1.3fr]" data-id="element-40" data-mp="3dc2pauflot7q">
                <h3 className="px-5 md:px-6 pt-4 md:py-5 font-serif text-lg font-bold text-forest" data-id="element-41" data-mp="39cc18yhgkr6w">
                  {row.situation}
                </h3>
                <p className="px-5 md:px-6 pt-2 md:py-5 font-sans text-[15px] text-forest/65 leading-[1.5]" data-id="element-42" data-mp="3n4rytjrlbx0f">
                  <span className="md:hidden block font-sans text-[10px] font-bold uppercase tracking-wider text-forest/50 mb-0.5" data-id="element-43" data-mp="2ue9ygqi949qp">
                    Ahora
                  </span>
                  {row.now}
                </p>
                <p className="mx-3 md:mx-0 mt-3 mb-4 md:my-0 rounded-xl md:rounded-none bg-sage-light/60 px-3 md:px-6 py-3 md:py-5 font-sans text-[15px] font-medium text-forest leading-[1.5]" data-id="element-44" data-mp="34cppktha3j07">
                  <span className="md:hidden block font-sans text-[10px] font-bold uppercase tracking-wider text-terracotta-deep mb-0.5" data-id="element-45" data-mp="jlp5sdbe8jet">
                    Con Pausa Propia
                  </span>
                  {row.with}
                </p>
              </li>)}
          </ul>
        </div>

        <ol className="mt-8 md:mt-10 grid grid-cols-3 gap-2 md:gap-6 text-center" data-id="element-46" data-mp="qondngtwk6f5">
          {changeSteps.map((step, i) => <li key={step.title} className="relative" data-id="element-47" data-mp="vp1as3tytvye" data-mpi={i}>
              <p className="font-serif text-xl md:text-3xl font-bold text-terracotta-deep" data-id="element-48" data-mp="10o4ijw1byga2">
                {step.title}
                {i < changeSteps.length - 1 && <span className="absolute right-0 translate-x-1/2 text-forest/30 font-sans font-normal" aria-hidden="true" data-id="element-49" data-mp="2xzs3sr2dia4">
                    →
                  </span>}
              </p>
              <p className="mt-1 font-sans text-[13px] md:text-[15px] text-forest/70 leading-[1.4]" data-id="element-50" data-mp="hoqkp30hclea">
                {step.text}
              </p>
            </li>)}
        </ol>

        <p className="mt-6 text-center font-sans text-[13px] md:text-sm font-semibold uppercase tracking-wider text-sage-deep" data-id="element-51" data-mp="3gcwdns1dkzz5">
          {changeNeeds.join(' · ')}
        </p>

        <p className="mt-5 text-center font-serif italic text-lg md:text-2xl text-forest" data-id="element-52" data-mp="3dtj9g1dayyr8">
          10 minutos pueden ser suficientes para empezar.
        </p>
      </div>
    </section>;
}